import { ColumnsModel } from "@syncfusion/ej2-react-querybuilder";
import { equalOperator, notEqualOperator } from ".";

export class BooleanColumn {
  constructor(private column: ColumnsModel) {}

  Operator = [equalOperator, notEqualOperator];

  ToColumn(): ColumnsModel {
    return {
      ...this.column,
      operators: this.Operator,
    };
  }
}
